export default "__VITE_ASSET__CDDwx5QO__"